import moment from 'moment';
import { callApi, getMainOpenWindowData, getHoursAndMinutes } from '../../utils';
import {
  REQUEST_BACKSTOPDATE,
  RECEIVE_BACKSTOPDATE,
  SET_BACKSTOPDATE_FAILURE,
  CLEAR_BACKSTOPDATE_ERROR_MESSAGE,
} from '../constants/backstopDate';

const requestBackstopdate = () => ({
  type: REQUEST_BACKSTOPDATE,
});

const receiveBackstopdate = backstopDate => ({
  type: RECEIVE_BACKSTOPDATE,
  backstopDate,
});

const setBackstopdateFailure = error => ({
  type: SET_BACKSTOPDATE_FAILURE,
  error,
});

export const clearBackstopdateErrorMessage = () => ({
  type: CLEAR_BACKSTOPDATE_ERROR_MESSAGE,
});

const getBackstopUrlParams = ({
  isHbs,
  numOfDaysBeforeBreak,
  isNumOfDaysBeforeBreakValid,
  rating,
  siteCode,
  mainOpenWindow,
  numOfDaysBeforeMainOpening = 0,
}) => {
  const baseUrl = `?Rating=${rating}&ShipCode=${siteCode.toUpperCase()}`;
  if (isHbs) return `${baseUrl}&Opendate=${moment(mainOpenWindow).add(numOfDaysBeforeMainOpening, 'days').format('YYYY-MM-DD')}`;
  return `${baseUrl}&${
    !isNumOfDaysBeforeBreakValid
      ? `Opendate=${moment(mainOpenWindow).format('YYYY-MM-DD')}`
      : `RollingDays=${numOfDaysBeforeBreak}`
  }`;
};

const getDepartureTimeAdjustedDate = (date, departureTime) => {
  const { hours, minutes } = getHoursAndMinutes(departureTime);
  const adjustedDate = moment(date).hour(hours).minute(minutes).second(0);
  return adjustedDate.format();
};

export const getBackstopDateFromApi = () => async (dispatch, getState) => {
  try {
    dispatch(requestBackstopdate());
    const { config, bookingSearch } = getState();
    const { arrivalDate, siteCode, seasonType, seasonSuffix, isHbs } = bookingSearch;
    const {
      REACT_APP_BOOKING_PREFIX: bookingPrefix,
      REACT_APP_BOOKING_SUBSCRIPTION_KEY: bookingSubscriptionKey,
      REACT_APP_API_TIMEOUT_MS: timeout,
      [`REACT_APP_NUMBER_OF_DAYS_BEFORE_BREAK${seasonSuffix}`]: numOfDaysBeforeBreak,
      REACT_APP_NUMBER_OF_DAYS_BEFORE_MAIN_OPENING: numOfDaysBeforeMainOpening,
      REACT_APP_DEPARTURE_TIME: departureTime = '11:00',
    } = config;
    const isNumOfDaysBeforeBreakValid = Number.isInteger(parseInt(numOfDaysBeforeBreak, 10));
    const { mainOpenWindow } = getMainOpenWindowData(config, arrivalDate, siteCode);
    const rating = seasonType === 'FAMILY' ? 'U' : '18';
    const urlParams = getBackstopUrlParams({
      isHbs,
      numOfDaysBeforeBreak,
      isNumOfDaysBeforeBreakValid,
      rating,
      siteCode,
      mainOpenWindow,
      numOfDaysBeforeMainOpening,
    });
    const { data = {} } = await callApi(
      {
        method: 'get',
        url: `/common/lookup/ents/calendar/backstopdate${urlParams}`,
      },
      bookingPrefix,
      bookingSubscriptionKey,
      timeout,
    );
    const { Data = {} } = data;
    dispatch(receiveBackstopdate(getDepartureTimeAdjustedDate(Data.BackstopDate, departureTime)));
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error(error); // eslint-disable-line
    dispatch(setBackstopdateFailure(error));
  }
};
